import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// import colors from 'vuetify/lib/util/colors'
import en from 'vuetify/src/locale/en.ts'
import ru from 'vuetify/src/locale/ru.ts'
import store from './../store'
// import i18n from '@/i18n'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  // lang: {
  //   t: (key, ...params) => i18n.t(key, params)
  // },
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    themes: {
      light: {
        primary: '#F47021',
        secondary: '#DB5A0D'
      }
    }
  },
  lang: {
    locales: { en, ru },
    current: store.state.locale
  }
})

store.subscribe(event => {
  if (event.type === 'updateLocale') {
    vuetify.framework.lang.current = event.payload
  }
})

export default vuetify
